import Immutable from "immutable";
import ProductStore from "../../../../AppData/_stores/ProductStore";
import VariantPriceStore from "../../../../UserData/_stores/Store/VariantPriceStore";
import PriceStore from "../../../../UIData/_stores/PriceStore";
import UserStorePresetStore from "../../../../UserData/_stores/Store/UserStorePresetStore";
import type { UserProductDesignStore } from "../../../../UserData/_stores/UserProductDesignStore";
import { StoreListingVariantPrices } from "./StoreListingVariantPrices";

type DefaultProductListing = {
	id: string
	id_product_design: number
	id_product: number
	title: string
	description: string
	price: PriceStore
	update_preset: boolean
	is_modified: boolean
	disabled_preview_ids: number[]
	disabled_option_ids: number[]
	variant_prices: Immutable.OrderedMap<string, VariantPriceStore>
}

export default function buildDefaultProductListing(
	productDesign: UserProductDesignStore,
	product: ProductStore,
	storePreset?: UserStorePresetStore,
): DefaultProductListing {
	const presetVariantPrices = StoreListingVariantPrices.normalizeOverrides(
		storePreset?.get('variant_prices') ?? Immutable.Map<string, VariantPriceStore>(), product, product.get('availableOptionTypes'),
	);
	const disabledOptionIds = storePreset?.get('disabled_option_ids') ?? Immutable.List<number>();
	const listingPrice = storePreset?.get('price') ?? product.get('price_retail');

	// Keep only saved overrides in the editable draft so defaults can follow later base edits.
	const listingVariantPrices = StoreListingVariantPrices.getDefaultPrices(product, productDesign.get('availableOptionTypes'), disabledOptionIds)
		.filter((variantPrice, id) => presetVariantPrices.has(id))
		.map((variantPrice, id) => variantPrice.set('price', presetVariantPrices.get(id)?.get('price') ?? variantPrice.get('price')));

	return {
		id: String(productDesign.get('id_product_design')),
		id_product_design: productDesign.get('id_product_design'),
		id_product: productDesign.get('id_product'),
		title: productDesign.get('name'),
		description: storePreset?.get('description') ?? '',
		price: listingPrice,
		update_preset: false,
		is_modified: false,
		disabled_preview_ids: storePreset?.get('disabled_preview_ids')?.toArray() ?? [],
		disabled_option_ids: storePreset?.get('disabled_option_ids')?.toArray() ?? [],
		variant_prices: listingVariantPrices,
	}
}
